import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/social-media-5187243_1280.webp")